import { Stack, Text } from "@mantine/core";
import { HeldEmailDetail } from "../../../services/admin/systemEmails.service";
import { HeldEmailDetailField } from "./HeldEmailDetailField";
import { HeldEmailFailureAlert } from "./HeldEmailFailureAlert";
import { HeldEmailCancellationDetails } from "./HeldEmailCancellationDetails";

interface HeldEmailDetailMetadataProps {
  detail: HeldEmailDetail;
  waitingTime: string;
}

export function HeldEmailDetailMetadata({
  detail,
  waitingTime,
}: HeldEmailDetailMetadataProps) {
  return (
    <Stack gap="xs">
      <Text fw={600}>{detail.subject}</Text>
      <HeldEmailDetailField label="Recipient" value={detail.recipient} />
      <HeldEmailDetailField label="Waiting" value={waitingTime} />
      <HeldEmailFailureAlert failureReason={detail.failureReason} />
      <HeldEmailCancellationDetails
        cancelledAt={detail.cancelledAt}
        cancelledByUserName={detail.cancelledByUserName}
      />
    </Stack>
  );
}
